import { cn } from "@repo/design-system/lib/utils";
import type { ReactNode } from "react";

type StatusTone = "error" | "warning" | "brand" | "neutral";

const toneStyles: Record<StatusTone, string> = {
	error: "bg-error-secondary text-error-primary",
	warning: "bg-warning-secondary text-warning-primary",
	brand: "bg-brand-secondary text-brand-primary",
	neutral: "bg-secondary text-tertiary",
};

type StatusScreenProps = {
	icon: ReactNode;
	title: string;
	description: ReactNode;
	tone?: StatusTone;
	actions?: ReactNode;
	footer?: ReactNode;
};

export function StatusScreen({
	icon,
	title,
	description,
	tone = "neutral",
	actions,
	footer,
}: StatusScreenProps) {
	return (
		<main className="flex min-h-screen w-full flex-col items-center justify-center bg-primary px-6 py-16 text-primary">
			<div className="flex w-full max-w-md flex-col items-center text-center">
				<div
					className={cn(
						"mb-5 flex size-14 items-center justify-center rounded-full [&_svg]:size-7",
						toneStyles[tone],
					)}
				>
					{icon}
				</div>
				<h1 className="mb-2 font-semibold text-primary text-xl">{title}</h1>
				<p className="max-w-sm text-balance text-secondary text-sm">
					{description}
				</p>
				{actions ? (
					<div className="mt-7 flex flex-col-reverse items-center gap-3 sm:flex-row">
						{actions}
					</div>
				) : null}
				{footer ? <div className="mt-8">{footer}</div> : null}
			</div>
		</main>
	);
}
